import { IMAGES } from "Helpers";

import CivicsSubImage from "Assets/Images/LandingPage/civics_logo.png";
import HistorySubImage from "Assets/Images/LandingPage/history_logo.png";
import ForeginLanguageSubImage from "Assets/Images/LandingPage/foreignlanguage_logo.png";
import MathSubImage from "Assets/Images/LandingPage/math_logo.png";
import EnglishSubImage from "Assets/Images/LandingPage/english_logo.png";
import EconomicsSubImage from "Assets/Images/LandingPage/economics_logo.png";
import ScienceSubImage from "Assets/Images/LandingPage/science_logo.png";

export const planDetails = [
    {
        planName: "Basic",
        planTitle: "Basic Plan",
        subType: [
            {
                type: "A",
                subTypeName: "Plan - 1",
                stickerImage: IMAGES.LANDING_PAGE.BASIC_PLAN_A,
                hoverEffectColor: "#c23030",
                allowedSubjects: 1,
                price: "$ 180.00",
                color: "#FFCCCC",
                innerDetails: {
                    permonth: "$ 30 / month",
                    subject: "Any 1 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 20 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "B",
                subTypeName: "Plan - 2",
                stickerImage: IMAGES.LANDING_PAGE.BASIC_PLAN_B,
                hoverEffectColor: "#5bb86b",
                allowedSubjects: 2,
                price: "$ 219.00",
                color: "#84F0CC",
                innerDetails: {
                    permonth: "$ 36.50 / month",
                    subject: "Any 2 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 20 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "C",
                subTypeName: "Plan - 3",
                stickerImage: IMAGES.LANDING_PAGE.BASIC_PLAN_C,
                hoverEffectColor: "#256af7",
                allowedSubjects: 3,
                price: "$ 249.00",
                color: "#ACEBFF",
                innerDetails: {
                    permonth: "$ 41.50 / month",
                    subject: "Any 3 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 20 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "D",
                subTypeName: "Plan - 4",
                stickerImage: IMAGES.LANDING_PAGE.BASIC_PLAN_D,
                hoverEffectColor: "#daca05",
                allowedSubjects: 7,
                price: "$ 399.00",
                color: "#FFDE5C",
                innerDetails: {
                    permonth: "$ 66.50 / month",
                    subject: "All Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 20 Students",
                    validity: "6 Months validity",
                },
            },
        ],
    },
    {
        planName: "Premium",
        planTitle: "Premium Plan",
        subType: [
            {
                type: "A",
                subTypeName: "Plan - 1",
                stickerImage: IMAGES.LANDING_PAGE.PREMIUM_PLAN_A,
                hoverEffectColor: "#c23030",
                allowedSubjects: 1,
                price: "$ 600.00",
                color: "#FFCCCC",
                innerDetails: {
                    permonth: "$ 100.00 / month",
                    subject: "Any 1 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 100 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "B",
                subTypeName: "Plan - 2",
                stickerImage: IMAGES.LANDING_PAGE.PREMIUM_PLAN_B,
                hoverEffectColor: "#5bb86b",
                allowedSubjects: 2,
                price: "$ 749.00",
                color: "#84F0CC",
                innerDetails: {
                    permonth: "$ 124.83 / month",
                    subject: "Any 2 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 100 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "C",
                subTypeName: "Plan - 3",
                stickerImage: IMAGES.LANDING_PAGE.PREMIUM_PLAN_C,
                hoverEffectColor: "#256af7",
                allowedSubjects: 3,
                price: "$ 899.00",
                color: "#ACEBFF",
                innerDetails: {
                    permonth: "$ 149.83 / month",
                    subject: "Any 3 Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 100 Students",
                    validity: "6 Months validity",
                },
            },
            {
                type: "D",
                subTypeName: "Plan - 4",
                stickerImage: IMAGES.LANDING_PAGE.PREMIUM_PLAN_D,
                hoverEffectColor: "#daca05",
                allowedSubjects: 7,
                price: "$ 1399.00",
                color: "#FFDE5C",
                innerDetails: {
                    permonth: "$ 233.17 / month",
                    subject: "All Subject",
                    teacher: "Any 1 Teacher",
                    students: "Up to 100 Students",
                    validity: "6 Months validity",
                },
            },
        ],
    },
    {
        planName: "Professional",
        planTitle: "Professional Plan",
        subType: [
            {
                type: "A",
                subTypeName: "Plan - 1",
                stickerImage: IMAGES.LANDING_PAGE.PROFESSIONAL_PLAN_A,
                hoverEffectColor: "#c23030",
                allowedSubjects: 7,
                price: "$ 5499.00",
                color: "#FFCCCC",
                innerDetails: {
                    permonth: "$ 458.25 / month",
                    subject: "All Subject",
                    teacher: "Unlimited Teachers",
                    students: "Up to 500 Students",
                    validity: "12 Months validity",
                },
            },
            {
                type: "B",
                subTypeName: "Plan - 2",
                stickerImage: IMAGES.LANDING_PAGE.PROFESSIONAL_PLAN_B,
                hoverEffectColor: "#5bb86b",
                allowedSubjects: 7,
                price: "$ 8499.00",
                color: "#84F0CC",
                innerDetails: {
                    permonth: "$ 708.25 / month",
                    subject: "All Subject",
                    teacher: "Unlimited Teachers",
                    students: "Up to 1000 Students",
                    validity: "12 Months validity",
                },
            },
            {
                type: "C",
                subTypeName: "Plan - 3",
                stickerImage: IMAGES.LANDING_PAGE.PROFESSIONAL_PLAN_C,
                hoverEffectColor: "#256af7",
                allowedSubjects: 7,
                price: "$ 11999.00",
                color: "#ACEBFF",
                innerDetails: {
                    permonth: "$ 999.92 / month",
                    subject: "All Subject",
                    teacher: "Unlimited Teachers",
                    students: "Up to 1500 Students",
                    validity: "12 Months validity",
                },
            },
            {
                type: "D",
                subTypeName: "Plan - 4",
                stickerImage: IMAGES.LANDING_PAGE.PROFESSIONAL_PLAN_D,
                hoverEffectColor: "#daca05",
                allowedSubjects: 7,
                price: "$ 14999.00",
                color: "#FFDE5C",
                innerDetails: {
                    permonth: "$ 1249.92 / month",
                    subject: "All Subject",
                    teacher: "Unlimited Teachers",
                    students: "Up to 2000 Students",
                    validity: "12 Months validity",
                },
            },
        ],
    },
];

export const subjectsArray = [
    {
        subjectId: 1,
        subject: "Civics",
        subjectStickerImage: IMAGES.LANDING_PAGE.CIVIC_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.CIVIC_NOTE,
        subjectPath: CivicsSubImage,
        backgroundGlowColor: "#004dff",
        borderColor: "#abb9ff ",
    },
    {
        subjectId: 2,
        subject: "History",
        subjectStickerImage: IMAGES.LANDING_PAGE.HISTORY_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.HISTORY_NOTE,
        backgroundGlowColor: "#06e4c9",
        subjectPath: HistorySubImage,
        borderColor: "#bbfff6 ",
    },
    {
        subjectId: 3,
        subject: "English",
        subjectStickerImage: IMAGES.LANDING_PAGE.ENGLISH_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.ENGLISH_NOTE,
        backgroundGlowColor: "#fff405",
        subjectPath: EnglishSubImage,
        borderColor: "#fff6a5 ",
    },
    {
        subjectId: 4,
        subject: "Science",
        subjectStickerImage: IMAGES.LANDING_PAGE.SCIENCE_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.SCIENCE_NOTE,
        backgroundGlowColor: "#a6ebca",
        subjectPath: ScienceSubImage,
        borderColor: "#b7eaff ",
    },
    {
        subjectId: 5,
        subject: "Math",
        subjectStickerImage: IMAGES.LANDING_PAGE.MATH_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.MATH_NOTE,
        backgroundGlowColor: "#c80400",
        subjectPath: MathSubImage,
        borderColor: "#ffb0b0 ",
    },
    {
        subjectId: 6,
        subject: "Economics",
        subjectStickerImage: IMAGES.LANDING_PAGE.ECONOMICS_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.ECONOMICS_NOTE,
        backgroundGlowColor: "#689cfb",
        subjectPath: EconomicsSubImage,
        borderColor: "#b6cfff ",
    },
    {
        subjectId: 7,
        subject: "Foreign Language",
        subjectStickerImage: IMAGES.LANDING_PAGE.FOREIGN_STICKER,
        subjectImage: IMAGES.LANDING_PAGE.FOREIGN_NOTE,
        backgroundGlowColor: "#00630e",
        subjectPath: ForeginLanguageSubImage,
        borderColor: "#b6ffce ",
    },
];
